<input
  #inputElement
  (keyup.enter)="save.emit(value)"
  class="form-control-sm"
  [(ngModel)]="value"
  [placeholder]="placeholder || ''"
  autofocus="true"
/>
<button eBtn color="primary" icon="save" class="ml-2" squared (click)="save.emit(value)"></button>
